import { useState } from "react";

const navItems = [
  { label: "首页", href: "#top" },
  { label: "专题索引", href: "#index" },
  { label: "热门更新", href: "#hot" },
  { label: "什么好看", href: "#guide" },
  { label: "资源速查", href: "#lookup" },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50">
      <div className="hidden md:block bg-foreground-950 text-background-100 text-xs">
        <div className="px-6 lg:px-10 h-9 flex items-center justify-between">
          <p className="font-label tracking-[0.22em] uppercase text-background-200">
            Mushroom Video · 专题合集浏览站
          </p>
          <div className="flex items-center gap-6">
            <span className="flex items-center gap-1.5 text-background-300">
              <i className="ri-refresh-line text-[13px]"></i>
              更新条每 10 分钟同步一次
            </span>
            <a
              href="#lookup"
              className="hover:text-accent-400 transition-colors cursor-pointer"
            >
              资源速查
            </a>
            <a
              href="#faq"
              className="hover:text-accent-400 transition-colors cursor-pointer"
            >
              常见问答
            </a>
          </div>
        </div>
      </div>

      <div className="bg-background-50/95 backdrop-blur border-b border-background-200">
        <div className="px-4 md:px-6 lg:px-10 h-16 flex items-center justify-between gap-4">
          <a href="#top" className="flex items-center gap-2.5 shrink-0 cursor-pointer">
            <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
              <i className="ri-play-fill text-[20px]"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading font-bold text-[18px] text-foreground-950">
                蘑菇视频
              </span>
              <span className="font-label text-[10px] tracking-[0.2em] uppercase text-foreground-400 mt-0.5">
                Mushroom Video
              </span>
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="px-4 py-2 rounded-md text-sm text-foreground-700 hover:text-foreground-950 hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="#sets"
              className="hidden md:inline-flex items-center gap-2 px-4 py-2 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-play-list-line"></i>
              短视频合集
            </a>
            <button
              type="button"
              aria-label="打开菜单"
              onClick={() => setOpen((v) => !v)}
              className="md:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-300 text-foreground-800 cursor-pointer"
            >
              <i className={open ? "ri-close-line text-[22px]" : "ri-menu-line text-[22px]"}></i>
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-background-50 border-b border-background-200 px-4 py-3">
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="px-3 py-3 rounded-md text-sm text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer border-b border-background-100 last:border-b-0"
              >
                {item.label}
              </a>
            ))}
          </nav>
          <a
            href="#sets"
            onClick={() => setOpen(false)}
            className="mt-3 flex items-center justify-center gap-2 px-4 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium cursor-pointer"
          >
            <i className="ri-play-list-line"></i>
            短视频合集
          </a>
        </div>
      )}
    </header>
  );
}